/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import axios from 'axios';

import './SearchBar.scss';

const page = 0;
const size = 20;
const aggregate = false;
const offset = 0;

function SearchBar({ query, setQuery, setSearch }) {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);

    const model = {
      name: {
        term: query,
      },
    };

    try {
      const data = await axios.post(`https://search.torre.co/people/_search/?page=${page}&size=${size}&aggregate=${aggregate}&offset=${offset}`, model);
      setSearch(data.data.results);
    } catch (error) {
      throw new Error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      { loading && <div className="loader">Loading...</div> }
      <div className="w-100">
        <form className="d-flex justify-content-center w-100">
          <input
            data-toggle="tooltip"
            data-placement="top"
            className="form-control mr-2 w-75 "
            type="search"
            title="input the name of a potential mentor"
            placeholder="Search"
            aria-label="Search"
            value={query}
            onChange={e => setQuery(e.target.value)}
          />
          <input
            className="btn btn-outline-primary my-2 my-sm-0"
            type="submit"
            value="Search"
            onClick={e => handleSubmit(e)}
          />
        </form>
      </div>
    </>
  );
}

export default SearchBar;
